import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import GestorJuridicoSidebar from '../pages/UsersArea/GestorJuridico/Sidebar/GestorJuridicoSidebar';

const GestorJuridicoLayout = () => {
  return (
    <Flex minH="100vh" bg="gray.50">
      {/* Sidebar */}
      <GestorJuridicoSidebar />
      
      {/* Main Content Area */}
      <Box
        flex="1"
        ml={{ base: 0, lg: "250px" }}
        p={{ base: 4, md: 6, lg: 8 }}
        maxW="100vw"
        overflowX="hidden"
      >
        <Outlet />
      </Box>
    </Flex>
  );
};

export default GestorJuridicoLayout;